import { useEffect, useState } from 'react';
import { auth } from '../firebase';

// Admin = the `admin: true` custom claim on the login token (security ledger SD-4).
// Google signs the token, so the page cannot fake it, and the database rules
// check the same claim. This hook only decides what the page shows; the rules
// are the real lock.
export const userIsAdmin = async (user) => {
  if (!user) return false;
  const token = await user.getIdTokenResult();
  return token.claims.admin === true;
};

// null while checking, then true or false.
const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    let active = true;
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      let result = false;
      try {
        result = await userIsAdmin(user);
      } catch (err) {
        console.error('Admin check failed:', err);
      }
      if (active) setIsAdmin(result);
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return isAdmin;
};

export default useIsAdmin;
